import type { MyRmSubscriptionMembersHandlersTypes } from '../api/endpoints/storeApi.types';

export const getCurrentMember = (
  members?: MyRmSubscriptionMembersHandlersTypes.ListMembers.Member[] | null
): MyRmSubscriptionMembersHandlersTypes.ListMembers.Member | null => {
  if (!members) return null;

  return members.find((seat) => seat.isCurrentUser) ?? null;
};
